export default __webpack_public_path__ + "static/media/grafema_martini-contest_12.70e0d0ae.jpg";